const DEFAULT_RETURN_URL = "/dashboard";

/** ログイン後の遷移先として安全な URL か判定（Open Redirect 対策） */
export function isSafeReturnUrl(url) {
    if (!url || typeof url !== "string") return false;
    if (!url.startsWith("/dashboard")) return false;
    if (url.startsWith("//")) return false;
    if (url.includes("://")) return false;
    return true;
}

/** location またはパス文字列から安全なログイン後遷移先を取得 */
export function getSafeReturnUrl(locationOrPath) {
    if (typeof locationOrPath === "string") {
        return isSafeReturnUrl(locationOrPath) ? locationOrPath : DEFAULT_RETURN_URL;
    }
    if (!locationOrPath) return DEFAULT_RETURN_URL;
    const full = `${locationOrPath.pathname || ""}${locationOrPath.search || ""}`;
    return isSafeReturnUrl(full) ? full : DEFAULT_RETURN_URL;
}
